import { useState } from "react";
import "./signupmodal.scss";

const SignupModal = ({
  closeSignupModal,
  closeModalAnimation,
  setCloseModalAnimation,
}) => {
  const [closeModal, setClosseModal] = useState(false);
  const [showSecondModal, setShowSecondModal] = useState(false);
  const [hideFirstModal, setHideFirstModal] = useState(false);

  const activateButtonAnimation = () => {
    setClosseModal(true);
    setTimeout(() => {
      setClosseModal(false);
    }, 3000);
    setTimeout(() => {
      closeSignupModal();
      setCloseModalAnimation(true);
      setTimeout(() => {
        setCloseModalAnimation(false);
      }, 1500);
    }, 2000);
  };

  const showSecondModalAction = (e) => {
    e.preventDefault();
    setHideFirstModal(true);
    setTimeout(() => {
      setShowSecondModal(true);
      setHideFirstModal(false);
    }, 100);
  };

  const closeModalWithAnimation = () => {
    setCloseModalAnimation(true);
    setTimeout(() => {
      closeSignupModal();
      setTimeout(() => {
        setCloseModalAnimation(false);
      }, 1500);
    }, 500);
  };

  return (
    <div
      className={`signup-modal-wrapper ${
        closeModalAnimation ? "hide-modal" : ""
      }`}
    >
      {!showSecondModal ? (
        <div className={`signup-modal ${hideFirstModal ? "hide-modal" : ""}`}>
          <button className="close-button" onClick={closeModalWithAnimation} />
          <span>
            sign up
            <br /> to try a dress
          </span>
          <form onSubmit={(e) => showSecondModalAction(e)}>
            <ul>
              <li>
                <input 
                required 
                type="text" placeholder="write your name" />
              </li>
              <li>
                <input
                 required 
                type="number" placeholder="your phone number" />
              </li>
              <li>
                <input
                  required
                  type="email"
                  placeholder="your e-mail address"
                />
              </li>
              <li>
                <input
                  required
                  type="text"
                  placeholder="select fitting date "
                />
              </li>
            </ul>
            <button
              type="submit"
              className="animated-button"
            >
              let's go
            </button>
          </form>
        </div>
      ) : (
        <div
          className={`signup-modal thankyou ${
            hideFirstModal ? "show-modal" : ""
          }`}
        >
          <button className="close-button" onClick={closeModalWithAnimation} />
          <span>THANK YOU!</span>
          <span>
            Your request has been accepted. During the day, our manager will
            contact you.
          </span>
          <div className="button-wrapper">
            <button
              className={`${closeModal ? "button-checked" : ""}`}
              onClick={activateButtonAnimation}
            >
              {!closeModal ? "COME BACK" : <div />}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SignupModal;
